"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertResolvedVariablesToWorkflowEngineVariables = exports.convertVariablesArrayToVariablesMap = exports.convertWorkflowEngineDatabaseVariablesToResolvedVariables = exports.convertVariablesToUIVariableGroups = exports.createBundleFromVariableAndVariableGroups = exports.convertUiVariableGroupsToUnresolvedVariables = exports.convertVariablesMapToUiVariableGroups = exports.convertUiVariablesToVariableBundle = void 0;
// Apologies for how gnarly these are. Just wanting to create all the the reductions in one pass, rather than four. 
function convertUiVariablesToVariableBundle(variables, currentGroup) {
    var result = variables.reduce(function (acc, cur) {
        var _a, _b;
        var transformedVariable = {
            id: cur.variableId,
            label: cur.variableName,
            valueType: cur.variableType || 'string',
            inputType: cur.type || 'unknown',
        };
        return {
            variables: __spreadArray(__spreadArray([], acc.variables), [transformedVariable]),
            variableLookup: __assign(__assign({}, acc.variableLookup), (_a = {}, _a[cur.variableId] = transformedVariable, _a)),
            variableGroupLookup: __assign(__assign({}, acc.variableGroupLookup), (_b = {}, _b[cur.variableId] = {
                label: cur.groupName || currentGroup.groupName,
                icon: cur.groupType || currentGroup.groupType
            }, _b))
        };
    }, {
        variables: [],
        variableLookup: {},
        variableGroupLookup: {},
    });
    return result;
}
exports.convertUiVariablesToVariableBundle = convertUiVariablesToVariableBundle;
function convertVariablesMapToUiVariableGroups(variablesMap, variableGroups) {
    var values = Object.values(variablesMap);
    if (variableGroups) {
        var uiVariableGroups = convertVariablesToUIVariableGroups(Object.values(variablesMap), variableGroups).uiVariableGroups;
        return uiVariableGroups;
    }
    return [
        {
            groupName: 'Variables',
            groupType: 'smsMessageVariables',
            variables: values.map(function (v) {
                return {
                    variableId: v.id,
                    variableName: v.label,
                    type: 'form',
                    groupName: 'Variables',
                    groupType: 'smsMessageVariables',
                };
            }),
        },
    ];
}
exports.convertVariablesMapToUiVariableGroups = convertVariablesMapToUiVariableGroups;
function convertUiVariableGroupsToUnresolvedVariables(variableGroups, transformVariableFn) {
    if (transformVariableFn === void 0) { transformVariableFn = function (v) { return v; }; }
    return variableGroups.reduce(function (acc, cur) {
        var variables = cur.variables.map(function (v) { return transformVariableFn(v); });
        var innerBundle = convertUiVariablesToVariableBundle(variables, __assign(__assign({}, cur), { variables: variables }));
        var transformedVariableGroup = {
            label: cur.groupName,
            icon: cur.groupType,
            variableIds: innerBundle.variables.map(function (v) { return v.id; })
        };
        return {
            variables: __spreadArray(__spreadArray([], acc.variables), innerBundle.variables),
            variableGroups: __spreadArray(__spreadArray([], acc.variableGroups), [
                transformedVariableGroup
            ]),
            variableLookup: __assign(__assign({}, acc.variableLookup), innerBundle.variableLookup),
            variableGroupLookup: __assign(__assign({}, acc.variableGroupLookup), innerBundle.variableGroupLookup)
        };
    }, {
        variables: [],
        variableGroups: [],
        variableLookup: {},
        variableGroupLookup: {}
    });
}
exports.convertUiVariableGroupsToUnresolvedVariables = convertUiVariableGroupsToUnresolvedVariables;
function createBundleFromVariableAndVariableGroups(variables, variableGroups) {
    var variableLookup = variables.reduce(function (acc, cur) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[cur.id] = cur, _a));
    }, {});
    var variableGroupLookup = variables.reduce(function (acc, cur) {
        var _a;
        var variableGroup = variableGroups.find(function (vg) { return vg.variableIds.includes(cur.id); });
        if (!variableGroup) {
            return acc;
        }
        return __assign(__assign({}, acc), (_a = {}, _a[cur.id] = variableGroup, _a));
    }, {});
    return {
        variables: variables,
        variableGroups: variableGroups,
        variableLookup: variableLookup,
        variableGroupLookup: variableGroupLookup
    };
}
exports.createBundleFromVariableAndVariableGroups = createBundleFromVariableAndVariableGroups;
function createUiVariableFromVariable(variable, variableGroup) {
    return {
        variableId: variable.id,
        variableName: variable.label,
        type: variableGroup.icon === "systemVariables" ? "system" : "form",
        inputType: variable.inputType,
        valueType: variable.valueType,
        groupName: variableGroup.label,
        groupType: variableGroup.icon
    };
}
function convertVariablesToUIVariableGroups(variables, variableGroups) {
    var uiVariableGroups = variableGroups.map(function (vg) {
        var variablesForThisGroup = variables.filter(function (v) { return vg.variableIds.includes(v.id); });
        var transformedVariables = variablesForThisGroup.map(function (v) {
            return createUiVariableFromVariable(v, vg);
        });
        return {
            groupName: vg.label,
            groupType: vg.icon,
            variables: transformedVariables
        };
    });
    var ungroupedVariables = variables.filter(function (v) {
        return !variableGroups.reduce(function (acc, cur) {
            return acc || cur.variableIds.includes(v.id);
        }, false);
    });
    var ungroupVariableGroup = ungroupedVariables.length > 0 ? [{
            groupName: "Variables",
            groupType: "formVariables",
            variables: ungroupedVariables.map(function (v) {
                return createUiVariableFromVariable(v, {
                    label: "Variables",
                    icon: "formVariables",
                    variableIds: [],
                });
            })
        }] : [];
    var allUiVariables = __spreadArray(__spreadArray([], uiVariableGroups), ungroupVariableGroup).reduce(function (acc, cur) {
        return __spreadArray(__spreadArray([], acc), cur.variables);
    }, []);
    return {
        uiVariableGroups: __spreadArray(__spreadArray([], uiVariableGroups), ungroupVariableGroup),
        uiVariables: __spreadArray([], allUiVariables)
    };
}
exports.convertVariablesToUIVariableGroups = convertVariablesToUIVariableGroups;
function convertWorkflowEngineDatabaseVariablesToResolvedVariables(dbVariables) {
    return dbVariables.map(function (v) {
        return {
            id: v.variable_id,
            value: v.variable_value,
            label: 'unknown',
            valueType: v.variable_type,
            inputType: 'unknown',
        };
    });
}
exports.convertWorkflowEngineDatabaseVariablesToResolvedVariables = convertWorkflowEngineDatabaseVariablesToResolvedVariables;
function convertVariablesArrayToVariablesMap(variables) {
    return variables.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item.id] = item, _a)));
    }, {});
}
exports.convertVariablesArrayToVariablesMap = convertVariablesArrayToVariablesMap;
/**
 *
 * This function converts resolvedVariables (responses that the user submits)
 * into a 'name - value' pair object which later then used
 * to map variables that are stored against the rootStep from the workflow definition.
 *
 * In the future this function will be deprecated as we start switching to listen from  the event stream to start a workflow
 *
 * see https://bitbucket.org/whispirdevops/workflow-engine/src/601e7bff21fda84a6e6ff0bacfc47feed5520b41/modules/operation-workflow-start/src/operationWorkflowStart.js#lines-112
 */
function convertResolvedVariablesToWorkflowEngineVariables(resolvedVariables) {
    return resolvedVariables.map(function (_a) {
        var id = _a.id, value = _a.value;
        return ({
            name: id,
            value: value,
        });
    });
}
exports.convertResolvedVariablesToWorkflowEngineVariables = convertResolvedVariablesToWorkflowEngineVariables;
